import type { FC } from "react"

import { ConfirmationDialog } from "@/components/common/Modals"

interface GoodsReceiptPalletDeleteConfirmationProps {
  onClose: () => void
  onConfirm: () => void | Promise<void>
}

export const GoodsReceiptPalletDeleteConfirmation: FC<GoodsReceiptPalletDeleteConfirmationProps> = ({
  onClose,
  onConfirm,
}) => {
  return (
    <ConfirmationDialog
      title='Are you sure you want to delete the pallet?'
      content='Deleting the pallet will remove this from inventory permanently.'
      closeLabel='Cancel'
      confirmLabel='Delete'
      onClose={onClose}
      onConfirm={onConfirm}
      isWarning
    />
  )
}
